import { useToken } from "@chakra-ui/react";

export const useColorTokens = () => {
  // Base colors
  const [base200, base300, base400, base500, base600, base700, base800] =
    useToken("colors", [
      "base.200",
      "base.300",
      "base.400",
      "base.500",
      "base.600",
      "base.700",
      "base.800",
    ]);

  // Brand colors
  const [brand400, brand500, brand600, brand700] = useToken("colors", [
    "brand.400",
    "brand.500",
    "brand.600",
    "brand.700",
  ]);

  // Action colors
  const [action200, action300, action400, action500, action600, action700] =
    useToken("colors", [
      "action.200",
      "action.300",
      "action.400",
      "action.500",
      "action.600",
      "action.700",
    ]);

  // Success colors
  const [
    success300,
    success400,
    success500,
    success600,
    success700,
    success800,
  ] = useToken("colors", [
    "success.300",
    "success.400",
    "success.500",
    "success.600",
    "success.700",
    "success.800",
  ]);

  // Warning colors
  const [warning300, warning400, warning500, warning600] = useToken("colors", [
    "warning.300",
    "warning.400",
    "warning.500",
    "warning.600",
  ]);

  // Danger colors
  const [danger300, danger400, danger500, danger600] = useToken("colors", [
    "danger.300",
    "danger.400",
    "danger.500",
    "danger.600",
  ]);

  // Line colors
  const [lines400, lines600] = useToken("colors", ["lines.400", "lines.600"]);

  // Highlight colors
  const [highlightWax500, highlightLilac500, highlightSpindle500] = useToken(
    "colors",
    ["highlightWax.500", "highlightLilac.500", "highlightSpindle.500"],
  );

  // Legacy colors
  const [legacyPillTagBorder, legacyLinkColor, legacyRoyalBlue500] = useToken(
    "colors",
    ["legacy.pillTag.border", "legacy.link.color", "legacy.royalBlue.500"],
  );

  return {
    base: {
      200: base200,
      300: base300,
      400: base400,
      500: base500,
      600: base600,
      700: base700,
      800: base800,
    },
    brand: {
      400: brand400,
      500: brand500,
      600: brand600,
      700: brand700,
    },
    action: {
      200: action200,
      300: action300,
      400: action400,
      500: action500,
      600: action600,
      700: action700,
    },
    success: {
      300: success300,
      400: success400,
      500: success500,
      600: success600,
      700: success700,
      800: success800,
    },
    warning: {
      300: warning300,
      400: warning400,
      500: warning500,
      600: warning600,
    },
    danger: {
      300: danger300,
      400: danger400,
      500: danger500,
      600: danger600,
    },
    lines: {
      400: lines400,
      600: lines600,
    },
    highlight: {
      wax: highlightWax500,
      lilac: highlightLilac500,
      spindle: highlightSpindle500,
    },
    legacy: {
      royalBlue: {
        500: legacyRoyalBlue500,
      },
      pillTag: {
        border: legacyPillTagBorder,
      },
      link: {
        color: legacyLinkColor,
      },
    },
  };
};
